import {Injectable} from '../../utils/DependencyInjection';

export class SimulatorUserAction implements Injectable {
  static dependencies = {};
  async init(_options: object = {}) {}
  async play(_options: object = {}) {}
}
